module.exports = __webpack_public_path__ + "img/exclamation.5999df26.svg";